var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowmore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.949,
    height: 6.995,
    viewBox: "0 0 6.949 6.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "show more"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 62",
    d: "m9 9.126 3.234-3.236a.328.328 0 0 0-.462-.462L8.805 8.4 5.923 5.513a.328.328 0 0 0-.462 0 .328.328 0 0 0 0 .465l3.148 3.148a.278.278 0 0 0 .393 0z",
    style: {
      fill: "#008da9"
    },
    transform: "translate(-5.364 -5.35)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 63",
    d: "m9 18.706 3.233-3.236a.328.328 0 0 0-.462-.462l-2.963 2.968-2.882-2.883a.328.328 0 0 0-.462 0 .328.328 0 0 0 0 .462l3.147 3.151a.278.278 0 0 0 .393 0z",
    transform: "translate(-5.367 -11.792)",
    style: {
      fill: "#008da9"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowmore);
export default __webpack_public_path__ + "static/media/show more.f1bb7b57f7198f38528c374246cb596e.svg";
export { ForwardRef as ReactComponent };